import * as React from "react";
export const TicketReminderIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={154.767}
      height={155.741}
      viewBox="0 0 154.767 155.741"
      {...props}
    >
      <g transform="translate(-14.781 -14.781)">
        <path
          d="M86,18.813A67.188,67.188,0,1,0,153.188,86,67.188,67.188,0,0,0,86,18.813Z"
          fill="none"
        />
        <path
          d="M86,157.219A71.219,71.219,0,1,1,157.219,86a4.031,4.031,0,0,1-8.062,0A63.156,63.156,0,1,0,86,149.156a4.031,4.031,0,0,1,0,8.063Z"
          fill="#252525"
        />
        <path
          id="triangle"
          d="M168.641,160.444,140.154,113.01a6.789,6.789,0,0,0-11.556,0L100.11,160.444a6.678,6.678,0,0,0-.134,6.719,6.559,6.559,0,0,0,5.912,3.359h56.841a6.719,6.719,0,0,0,5.913-10.078Z"
          fill="#f7b500"
        />
        <path
          d="M134.375,147.813a3.959,3.959,0,0,1-4.031-4.031V130.344a4.031,4.031,0,0,1,8.063,0v13.438A3.959,3.959,0,0,1,134.375,147.813Zm0,13.437a3.66,3.66,0,0,1-2.822-1.209,2.932,2.932,0,0,1-.538-.672c-.134-.269-.269-.4-.4-.672s-.134-.538-.269-.806c0-.269-.134-.538-.134-.806a3.66,3.66,0,0,1,1.209-2.822,4.146,4.146,0,0,1,5.644,0,3.867,3.867,0,0,1,1.209,2.822,1.7,1.7,0,0,1-.134.806,1.91,1.91,0,0,1-.269.806,2.938,2.938,0,0,1-.4.672,2.359,2.359,0,0,1-.538.672,2.8,2.8,0,0,1-2.553,1.209Z"
          fill="#fff"
        />
        <path
          d="M119.594,81.969H98.766a13.214,13.214,0,0,0-8.734-8.734V38.969a4.031,4.031,0,0,0-8.062,0V73.234A13.407,13.407,0,0,0,86,99.438a13.185,13.185,0,0,0,12.766-9.406h20.828a4.031,4.031,0,0,0,0-8.062ZM86,91.375A5.375,5.375,0,1,1,91.375,86,5.391,5.391,0,0,1,86,91.375Z"
          fill="#252525"
        />
      </g>
    </svg>
  );
};
